export const translations = {
  'pt-BR': {
    // Navbar
    articles: 'Artigos',
    articlesDescription: 'Pensamentos sobre desenvolvimento web, Ruby on Rails, Vue.js e mais.',
    noArticlesYet: 'Nenhum artigo ainda. Volte em breve!',
    about: 'Sobre',
    projects: 'Projetos',
    contact: 'Contato',

    // Hero
    available: 'Aberto para projetos freelance',
    roleTitle: 'Desenvolvedor Full-Stack',
    headline: 'Software que vai pro ar. E fica lá.',
    tagline: 'Construo software que vai pra produção — apps web, plataformas de dados e integrações de IA que aguentam a demanda.',
    seeMyWork: 'Ver Meu Trabalho',
    getInTouch: 'Entre em Contato',
    connectLinkedIn: 'Conectar no LinkedIn',

    // About
    aboutMe: 'Sobre Mim',
    aboutHeading: 'Um pouco sobre mim',
    aboutText1: 'Sou {highlight} na Pontus Vision desde outubro de 2022, trabalhando remotamente entre Reino Unido e Brasil. No dia a dia, construo aplicações com React, Node.js e TypeScript, processo dados com Databricks e Spark SQL, e desenvolvo funcionalidades com IA.',
    fullStackDeveloper: 'Desenvolvedor Full-Stack',
    aboutText2: 'Estudei Ciência da Computação na UNIFESO e passei pelo programa Full-Stack da SERRATEC. Gosto de arquiteturas limpas, testes automatizados e de construir coisas que funcionam de verdade em produção.',
    yearsExperience: 'Anos de Experiência',
    projectsCompleted: 'Projetos Concluídos',
    coffeeConsumed: 'Xícaras de Café',
    frontend: 'Frontend',
    frontendDesc: 'React, Vue.js, Next.js, Nuxt, TypeScript, Tailwind CSS',
    backend: 'Backend',
    backendDesc: 'Node.js, Python, Ruby on Rails, C#, .NET, PostgreSQL',
    aiMl: 'IA & ML',
    aiMlDesc: 'LLMs, Agentes de IA, RAG, Databricks, Spark SQL',
    devops: 'DevOps',
    devopsDesc: 'Docker, GitHub Actions, Azure, AWS, Terraform',

    // Projects / Chat
    aiAssistant: 'Assistente AI',
    chatWithMy: 'Converse com meu',
    aiTwin: 'Gêmeo AI',
    chatSubtitle: 'Curioso sobre meu trabalho, habilidades ou experiência? Pergunte ao meu assistente AI — ele sabe tudo sobre mim!',
    paulosAiAssistant: 'Assistente AI do Paulo',
    poweredBy: 'Desenvolvido com grep + Gemini',
    online: 'Online',
    thinking: 'Pensando...',
    askAnything: 'Pergunte qualquer coisa sobre Paulo...',
    chatGreeting: 'Olá! Sou o assistente AI do Paulo. Pergunte sobre habilidades, experiência ou projetos.',
    promptSkills: 'Suas habilidades?',
    promptProjects: 'Me mostre seus projetos',
    promptExperience: 'Experiência profissional?',
    promptTech: 'Stack de tecnologia?',
    errorOccurred: 'Desculpe, ocorreu um erro. Tente novamente.',

    // Contact
    contactLabel: 'Contato',
    lets: 'Vamos',
    workTogether: 'trabalhar juntos',
    contactSubtitle: 'Fique à vontade para entrar em contato por email ou conectar comigo no LinkedIn.',
    email: 'E-mail',
    linkedin: 'LinkedIn',
    linkedinDesc: 'Conecte-se comigo',
    github: 'GitHub',
    githubDesc: 'Veja meu código',
    orDropMessage: 'Ou me envie uma mensagem diretamente',
    sendMessage: 'Enviar Mensagem',

    // Article
    shareOnLinkedIn: 'Compartilhar no LinkedIn',
    shareArticle: 'Gostou deste artigo? Compartilhe no LinkedIn!',

    // Footer
    craftedWithPassion: 'Feito com Vue, Rails & café.',

    // Dark mode
    switchToLight: 'Mudar para modo claro',
    switchToDark: 'Mudar para modo escuro',

    // Months
    months: {
      january: 'Janeiro',
      february: 'Fevereiro',
      march: 'Março',
      april: 'Abril',
      may: 'Maio',
      june: 'Junho',
      july: 'Julho',
      august: 'Agosto',
      september: 'Setembro',
      october: 'Outubro',
      november: 'Novembro',
      december: 'Dezembro'
    }
  },

  'en-US': {
    // Navbar
    articles: 'Articles',
    articlesDescription: 'Thoughts on web development, Ruby on Rails, Vue.js, and more.',
    noArticlesYet: 'No articles yet. Check back soon!',
    about: 'About',
    projects: 'Projects',
    contact: 'Contact',

    // Hero
    available: 'Open to freelance projects',
    roleTitle: 'Full-Stack Developer',
    headline: 'Software that ships. And stays shipped.',
    tagline: 'I build software that ships — web apps, data platforms, and AI features that hold up in production.',
    seeMyWork: 'See My Work',
    getInTouch: 'Get in Touch',
    connectLinkedIn: 'Connect on LinkedIn',

    // About
    aboutMe: 'About Me',
    aboutHeading: 'A bit about my background',
    aboutText1: "I've been a {highlight} at Pontus Vision since October 2022, working remotely between the UK and Brazil. Day to day I build apps with React, Node.js and TypeScript, process data with Databricks and Spark SQL, and develop AI-powered features.",
    fullStackDeveloper: 'Full-Stack Developer',
    aboutText2: "I studied Computer Science at UNIFESO and went through the SERRATEC Full-Stack program. I care about clean architecture, automated testing, and building things that actually work in production.",
    yearsExperience: 'Years Experience',
    projectsCompleted: 'Projects Completed',
    coffeeConsumed: 'Cups of Coffee',
    frontend: 'Frontend',
    frontendDesc: 'React, Vue.js, Next.js, Nuxt, TypeScript, Tailwind CSS',
    backend: 'Backend',
    backendDesc: 'Node.js, Python, Ruby on Rails, C#, .NET, PostgreSQL',
    aiMl: 'AI & ML',
    aiMlDesc: 'LLMs, AI Agents, RAG, Databricks, Spark SQL',
    devops: 'DevOps',
    devopsDesc: 'Docker, GitHub Actions, Azure, AWS, Terraform',

    // Projects / Chat
    aiAssistant: 'AI Assistant',
    chatWithMy: 'Chat with my',
    aiTwin: 'AI Twin',
    chatSubtitle: "Curious about my work, skills, or experience? Ask my AI assistant — it knows everything about me!",
    paulosAiAssistant: "Paulo's AI Assistant",
    poweredBy: 'Powered by grep + Gemini',
    online: 'Online',
    thinking: 'Thinking...',
    askAnything: 'Ask me anything about Paulo...',
    chatGreeting: "Hi! I'm Paulo's AI assistant. Ask about his skills, experience, or projects.",
    promptSkills: 'Your skills?',
    promptProjects: 'Show me your projects',
    promptExperience: 'Your experience?',
    promptTech: 'Tech stack?',
    errorOccurred: 'Sorry, an error occurred. Please try again.',

    // Contact
    contactLabel: 'Contact',
    lets: "Let's",
    workTogether: 'work together',
    contactSubtitle: 'Feel free to reach out by email or connect with me on LinkedIn.',
    email: 'Email',
    linkedin: 'LinkedIn',
    linkedinDesc: 'Connect with me',
    github: 'GitHub',
    githubDesc: 'View my code',
    orDropMessage: 'Or drop me a message directly',
    sendMessage: 'Send Message',

    // Article
    shareOnLinkedIn: 'Share on LinkedIn',
    shareArticle: 'Enjoyed this article? Share it on LinkedIn!',

    // Footer
    craftedWithPassion: 'Built with Vue, Rails & coffee.',

    // Dark mode
    switchToLight: 'Switch to light mode',
    switchToDark: 'Switch to dark mode',

    // Months
    months: {
      january: 'January',
      february: 'February',
      march: 'March',
      april: 'April',
      may: 'May',
      june: 'June',
      july: 'July',
      august: 'August',
      september: 'September',
      october: 'October',
      november: 'November',
      december: 'December'
    }
  }
}

export const locales = [
  { code: 'pt-BR', name: 'PT', flag: '🇧🇷' },
  { code: 'en-US', name: 'EN', flag: '🇺🇸' }
]
